__turbopack_context__.v({
  "badge": "CheckboxListItemRepresentation-module-scss-module__VhLHFG__badge",
  "checkbox": "CheckboxListItemRepresentation-module-scss-module__VhLHFG__checkbox",
  "content": "CheckboxListItemRepresentation-module-scss-module__VhLHFG__content",
  "disabled": "CheckboxListItemRepresentation-module-scss-module__VhLHFG__disabled",
  "root": "CheckboxListItemRepresentation-module-scss-module__VhLHFG__root",
});
